import React, { FC } from 'react';
import { NavLink } from "react-router-dom";
import { HoverProvider, IconBox, Type as T } from "@infobis/ui-styles-utils";

import st from "./logo.module.scss";
import cn from "classnames";

interface ILogo {
    showText?: boolean
    color?: T.Color
    size?: 'm' | 'l'
    hoverColor?: T.Color
}

const Logo: FC<ILogo> = (props) => {
    let {
        showText = true,
        color = "#ACC4E5",
        size = 'm',
        hoverColor = "#FFFFFF"
    } = props

    return (
        <HoverProvider>
            <div className={st.logo}
                 style={{ '--icon-color': color, '--icon-hover-color': hoverColor } as React.CSSProperties}>
                <NavLink to={"/"} className={st.link}>
                    <IconBox
                        icon={T.IconName.Logotype}
                        color={color}
                        hoverColor={hoverColor}
                        className={st.icon}
                    />
                    {showText ?
                        <div className={cn(st.label, st['label--' + size])}>
                            Агросигнал
                        </div> :
                        null
                    }
                </NavLink>
            </div>
        </HoverProvider>
    )
}
export default Logo